import { Component, OnInit } from '@angular/core';
import { DashboardData } from '../model/dashboard.model';
import { ApiService } from '../services/api.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  dashboardDetails: DashboardData = null;
  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    const employeeId = Number(window.localStorage.getItem('loggedInUser'));
    this.apiService.getDasboradDetails(employeeId).subscribe(data => {
      this.dashboardDetails = data;
    });
  }

}
